module.exports = __webpack_public_path__ + "static/media/tag@3x.baf17080.png";